import PrimaryUrlService from "../services/primaryUrlService";

export default class SessionGuard {
    $sessionService;
    $primaryUrlService;

    constructor(sessionService) {
        this.$sessionService = sessionService;
        this.$primaryUrlService = new PrimaryUrlService();
    }

    check(to, from, next) {
        this.$sessionService.isLogged()
            .then(
                () => next()
            )
            .catch(
                () => {
                    this.$primaryUrlService.storeUrl();
                    return next({
                        name: 'login'
                    })
                }
            )

    }
}
